export default __webpack_public_path__ + "static/media/img40.eebcb914.jpg";